<div class="responsive-table">
    <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="row-border hover">
        <thead>
        <tr>
            <th class="all trigger-column"></th>
            <th *ngFor="let column of columns" [ngClass]="column.classes" translate>{{ column.i18n || column.title }}</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let item of displayedItems">
            <td class="trigger-cell"></td>
            <td *ngFor="let column of columns" [ngClass]="column.classes">
                <span *ngIf="!column.isRowActions" [innerHtml]="item[column.itemProperty]"></span>
                <div class="row-actions" *ngIf="column.isRowActions">
                    <div class="buttons-menu" [class.always]="column.shouldAlwaysShowActionMenu" *ngIf="item[column.itemProperty].length">
                        <button mat-button type="button" [matMenuTriggerFor]="actions" class="actions">
                            <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #actions="matMenu" xPosition="before">
                            <button mat-menu-item
                                    type="button"
                                    class="action-menu-item"
                                    *ngFor="let action of item[column.itemProperty]"
                                    (click)="takeAction($event, action.key, item)">
                                <span class="icon"><mat-icon>{{ action.icon }}</mat-icon></span>
                                <span class="text" translate>{{ action.i18n || action.text }}</span>
                            </button>
                        </mat-menu>
                    </div>
                    <div class="buttons-explicit" [class.never]="column.shouldAlwaysShowActionMenu">
                        <button mat-raised-button
                                type="button"
                                class="action-item"
                                *ngFor="let action of item[column.itemProperty]"
                                (click)="takeAction($event, action.key, item)">
                            <span class="icon"><mat-icon>{{ action.icon }}</mat-icon></span>
                            <span class="text" translate>{{ action.i18n || action.text }}</span>
                        </button>
                    </div>
                </div>
            </td>
        </tr>
        </tbody>
    </table>

    <upsc-element-blocker *ngIf="isLoading"></upsc-element-blocker>
</div>

<mat-paginator *ngIf="usePaginator"
               [length]="totalItemCount"
               [pageSize]="pageSize"
               [pageIndex]="pageIndex"
               (page)="onPageChanged($event)"></mat-paginator>